<template>
  <b-modal
    id="land-data-modal"
    ref="land-data-modal"
    title="Select Land"
    size="xl"
    ok-title="Submit"
    @ok="handleSubmit"
    @hidden="resetModal"
  >
    <b-table
      ref="landTable"
      responsive
      :items="landItems"
      :fields="fields"
      :busy="isBusy"
      class="mt-2"
      show-empty
      sticky-header="600px"
    >
      <template #cell(select)="data">
        <b-form-checkbox
          :checked="selected && selected.id === data.item.id"
          @change="handleCheckboxChange(data.item)"
        />
      </template>
      <template #table-busy>
        <div class="text-center text-danger my-2">
          <b-spinner class="align-middle" />
          <strong>Loading...</strong>
        </div>
      </template>
    </b-table>
  </b-modal>
</template>

<script>
import {
  BModal,
  BTable,
  BSpinner,
  BFormCheckbox,
} from 'bootstrap-vue'
import axios from '@axios'

export default {
  props: {
    initialSelectedIds: {
      type: String,
      default: '',
    },
  },
  components: {
    BModal,
    BTable,
    BSpinner,
    BFormCheckbox,
  },
  data() {
    return {
      fields: [
        { key: 'select', label: '' },
        { key: 'villagename', label: 'Village Name' },
        { key: 'surveynonew', label: 'Survey No. New' },
        { key: 'surveynoold', label: 'Survey No. Old' },
        { key: 'fpno', label: 'FP. No' },
        { key: 'orignalplotno', label: 'Original Plot No.' },
        { key: 'khatano', label: 'Khata No' },
        { key: 'subtpno', label: 'SUB TP' },
        { key: 'zone', label: 'Zone' },
        // { key: 'khatano', label: 'TP ROAD' },
        { key: 'fparea', label: 'FP AREA - SQ.YARD' },
        // { key: 'khatano', label: 'FP AREA - SQ.FEET' },
        { key: 'cprate', label: 'RATE - PER SQ. YARD' },
        // { key: 'khatano', label: 'RATE - PER SQ. FEET' },
        { key: 'remarks', label: 'REMARKS' },
      ],
      landItems: [],
      isBusy: false,
      selected: null,
      accessToken: localStorage.getItem("accessToken"),
      baseApi: process.env.VUE_APP_APIENDPOINT,
    }
  },
  mounted() {
    this.fetchLandData();
    this.$refs['land-data-modal'].$on('show', this.initializeSelection);
  },
  beforeDestroy() {
    if (this.$refs['land-data-modal']) {
      this.$refs['land-data-modal'].$off('show', this.initializeSelection);
    }
  },
  methods: {
    initializeSelection() {
      if (this.initialSelectedIds) {
        const selectedId = parseInt(this.initialSelectedIds, 10);
        this.selected = this.landItems.find(item => item.id === selectedId) || null;
      } else {
        this.selected = null;
      }
    },
    async fetchLandData() {
      this.isBusy = true
      await axios({
        method: "GET",
        url: `${this.baseApi}/allLand`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.accessToken}`,
        },
      })
        .then((json) => {
          this.landItems = json.data.data
          this.isBusy = false
        })
        .catch((error) => {
          console.error(error)
          this.isBusy = false
        });
    },
    handleCheckboxChange(item) {
      if (this.selected && this.selected.id === item.id) {
        this.selected = null;
      } else {
        this.selected = item;
      }
    },
    handleSubmit() {
      if(this.selected) {
        this.$emit('land-selected', this.selected)
      }
      this.$refs['land-data-modal'].hide()
    },
    resetModal() {
      this.selected = null
    },
  },
}
</script>
